var map = {
	"./logo_cn_de.svg": 42429,
	"./logo_cn_en.svg": 93317,
	"./logo_cn_fr.svg": 96268,
	"./logo_cn_invert_de.svg": 85790,
	"./logo_cn_invert_en.svg": 71782,
	"./logo_cn_invert_fr.svg": 89835,
	"./logo_cn_invert_nl.svg": 15861,
	"./logo_cn_nl.svg": 9858
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44582;